import { PostJobStep } from '../../../../../store/workspace/types';
import MotionWrapper from '../../../../../layouts/MotionWrapper';
import DropDown from '../../../../../components/DropDown';
import Button from '../../../../../components/Button';
import Input from '../../../../../components/Input';
import styles from './style.module.scss';
import {
    City,
    Country,
    ListItem,
    CountryState,
} from '../../../../../store/general/types';
import {
    jobTypeList,
    workplaceTypeList,
    salaryFrequencyList,
} from '../../../../../configs';
import {
    Dispatch,
    SetStateAction,
} from 'react';
import {
    cityInit,
    countryInit,
    countryStateInit,
} from '../../../../../store/general/constants';

interface Props {
    city: City;
    state: CountryState;
    cities: City[];
    country: Country;
    jobTitle: string;
    salaryAmount: string;
    countries: Country[];
    states: CountryState[];
    jobType: ListItem | null;
    workplaceType: ListItem | null;
    salaryFrequency: ListItem | null;
    setStep: (step: PostJobStep) => void;
    setCityAndState: (city: City) => void;
    setCity: Dispatch<SetStateAction<City>>;
    setCountry: Dispatch<SetStateAction<Country>>;
    setJobTitle: Dispatch<SetStateAction<string>>;
    setState: Dispatch<SetStateAction<CountryState>>;
    setSalaryAmount: Dispatch<SetStateAction<string>>;
    setJobType: Dispatch<SetStateAction<ListItem | null>>;
    setWorkplaceType: Dispatch<SetStateAction<ListItem | null>>;
    setSalaryFrequency: Dispatch<SetStateAction<ListItem | null>>;
    next: () => void;
};

function JobDetail(props: Props) {
    const {
        city,
        state,
        states,
        cities,
        jobType,
        country,
        jobTitle,
        countries,
        salaryAmount,
        workplaceType,
        salaryFrequency,
        setCity,
        setState,
        setStep,
        setCountry,
        setJobType,
        setJobTitle,
        setCityAndState,
        setSalaryAmount,
        setWorkplaceType,
        setSalaryFrequency,
        next,
    } = props;

    return (
        <MotionWrapper className={styles.container}>
            <span className={styles.title}>Step 1 - Job information</span>
            <Input
                isRequired
                type='text'
                placeholder=''
                label='Job title'
                value={jobTitle}
                onChange={setJobTitle}
            />
            <div className={styles.row}>
                <Input
                    isRequired
                    type='text'
                    placeholder=''
                    label='Job base salary amount'
                    value={salaryAmount}
                    onChange={setSalaryAmount}
                    wrapperClassName={styles.row_input}
                />
                <DropDown
                    idKey='id'
                    isRequired
                    titleKey='title'
                    label='Salary frequency'
                    setItem={setSalaryFrequency}
                    selectedItem={salaryFrequency}
                    dropDownList={salaryFrequencyList}
                    containerClassName={styles.row_dropdown}
                />
            </div>
            <DropDown
                isRequired
                label='Workplace type'
                dropDownList={workplaceTypeList}
                selectedItem={workplaceType}
                setItem={setWorkplaceType}
                titleKey='title'
                idKey='id'
            />
            <DropDown
                isRequired
                label='Job type'
                dropDownList={jobTypeList}
                selectedItem={jobType}
                setItem={setJobType}
                titleKey='title'
                idKey='id'
            />
            <Input
                label='City (job location)'
                type='text'
                isRequired
                value={city.city}
                list={cities}
                placeholder=''
                listIdKey='id'
                listTitleKey='city'
                listTitleSuffixKey='state_code'
                onItemClick={(item: City) => setCityAndState(item)}
                onChange={(val: string) => setCity({ ...cityInit, city: val })}
            />
            <Input
                type='text'
                isRequired
                placeholder=''
                listIdKey='id'
                label='Country'
                value={country.title}
                listTitleKey='title'
                onItemClick={(item: Country) => setCountry(item)}
                onChange={(val: string) => setCountry({ ...countryInit, title: val })}
                list={countries.filter(i => i.title.toLowerCase().startsWith(country.title.toLowerCase()))}
            />
            <Input
                type='text'
                label='State'
                isRequired
                value={state.state}
                placeholder=''
                listIdKey='id'
                listTitleKey='state'
                onItemClick={(item: CountryState) => setState(item)}
                onChange={(val: string) => setState({ ...countryStateInit, state: val })}
                list={states.filter(i => i.state.toLowerCase().startsWith(state.state.toLowerCase()))}
            />
            <Button
                type='Primary'
                text='Save & Continue'
                className={styles.next}
                onClick={next}
            // disabled={
            //     !jobTitle ||
            //     !jobType ||
            //     !city.city ||
            //     !state.state ||
            //     !country.title ||
            //     !salaryAmount ||
            //     !salaryFrequency ||
            //     !workplaceType
            // }
            />
        </MotionWrapper >
    )
};

export default JobDetail;
